// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import myw from 'myWorld/base/core';
import 'myWorld/base/svgRenderer';
import './layerControlWidget';

/**
 * @class Provides legend for vector layers.
 * @name MyWorldLegendLayerControlWidget
 * @constructor
 * @extends {LayerControlWidget}
 */
myw.MyWorldLegendLayerControlWidget = myw.ILayerControlWidget.extend({
    tagName: 'div',
    className: 'vector-legend',

    events: {
        click: 'noop'
    },

    render() {
        const layer = this.options.layer;
        const featureTypes = layer.layerDef.feature_types;

        const withName = _.each(featureTypes, featureType => {
            featureType.label = this._getFeatureExternalName(layer, featureType.name);
        });
        const sorted = _.sortBy(withName, 'label');
        _.each(sorted, featureType => {
            if (null != featureType.fill_style && null != featureType.line_style) {
                const fillStyle = featureType.fill_style.split(':');
                const borderStyle = featureType.line_style.split(':');
                this.$el.append(
                    `<div><div class="icon polygon" style=";border: solid 2px ${
                        borderStyle[0]
                    };"><div style="width:100%;height:100%;background:${
                        fillStyle[0]
                    };opacity:${fillStyle[1] / 100}"></div></div><span class="label">${
                        featureType.label
                    }</span></div>`
                );
            } else if (null != featureType.point_style) {
                const el = $('<div/>');
                el.append(
                    $('<div/>', {
                        class: 'icon',
                        html: this.renderPoint(featureType.point_style)
                    })
                );
                el.append(
                    $('<span/>', {
                        class: 'label',
                        html: featureType.label
                    })
                );
                this.$el.append(el);
            } else if (null != featureType.line_style) {
                this.$el.append(
                    `<div><div class="icon">${this.renderLine(
                        featureType.line_style
                    )}</div><span class="label">${featureType.label}</span></div>`
                );
            }
        });
    },

    renderPoint(style) {
        const config = style.split(':');
        const pointSymbolName = config[0];
        const pointSymbolColour = config[1] || 'transparent';
        const pointSymbolBorderColour = config[3] || 'transparent';

        if (myw.svgRenderer.symbols[pointSymbolName]) {
            const svg = myw.svgRenderer.render(pointSymbolName);
            svg.style.height = '16px';
            svg.style.width = '16px'; //fixes alignment in ie
            svg.style.fill = pointSymbolColour;
            svg.style.transform = 'rotate(180deg)';
            if (pointSymbolBorderColour) {
                svg.style.stroke = pointSymbolBorderColour;
                svg.style.strokeWidth = '4px';
            }
            return svg;
        }

        return $('<img/>', { src: pointSymbolName, height: '16px' });
    },

    renderLine(style) {
        const conf = style.split(':');
        const color = conf[0];
        let ends = 0;
        if (conf[3] != 'none' || conf[4] != 'none') ends = 1;
        if (conf[3] != 'none' && conf[4] != 'none') ends = 2;

        let line = '';
        if (conf[3] == 'arrow') {
            line += `<span class="arrow-begin"><span class="arrow-left" style="border-right-color:${color}"></span></span>`;
        }
        line += this._renderLineStyle(conf[2], color, ends);
        if (conf[4] == 'arrow') {
            line += `<span class="arrow-end"><span class="arrow-right" style="border-left-color:${color}"></span></span>`;
        }
        return line;
    },

    _getFeatureExternalName(layer, type) {
        return layer.datasource.featuresDD[type].external_name;
    },

    _renderLineStyle(style, color, ends) {
        switch (style) {
            case 'shortdash':
                return `<span class="shortdash-line" style="border-bottom-color:${color}"><span class="shortdash"></span><span class="shortdash"></span><span class="shortdash"></span><span class="shortdash"></span><span class="shortdash"></span></span>`;

            case 'dot':
                return `<span class="dot-line" style="border-bottom-color:${color}"></span>`;
            case 'dash':
                return `<span class="dash-line" style="border-bottom-color:${color}"></span>`;
            case 'longdash':
                return `<span class="longdash-line" style="border-bottom-color:${color}"><span class="longdash"></span><span class="longdash"></span></span>`;
            case 'longdashdot':
                return `<span class="longdashdot-line" style="border-bottom-color:${color}"><span class="longdash"></span><span class="dot"></span></span>`;
            case 'solid':
                return `<span class="solid-line" style="border-bottom-color:${color}"></span>`;
        }
    },

    noop(ev) {
        ev.stopPropagation();
    }
});

export default myw.MyWorldLegendLayerControlWidget;
